import {

    DEPARTMENT_LIST_REQUESTED,
    DEPARTMENT_LIST_PROCESSING,
    DEPARTMENT_LIST_SUCCESSED,
    DEPARTMENT_LIST_FAILED,

  } from '../../constants/actionTypes';
  
  const initialState = {
    listData: {},
    singleData:null,
    isUpdated:null,
    isProcessing: null,
    isSuccess: null,
    hasErrors: null,
  };
 

  export const departmentsStore = (state = initialState, action) => {
    switch (action.type) {
        case DEPARTMENT_LIST_REQUESTED: {
            return {
            ...state,
            listData: {},
            error: null,
            loading: true,
            requested: true,
            };
        }
        case DEPARTMENT_LIST_PROCESSING: {
            return {
            ...state,
            listData: {},
            error: null,
            loading: true,
            requested: false,
            };
        }
        case DEPARTMENT_LIST_SUCCESSED: {
            return {
                ...state,
                listData: action.data,
                error: null,
                loading: false,
                requested: false,
            };
        }
        case DEPARTMENT_LIST_FAILED: {
            return {
                ...state,
                listData: {},
                error: action.data,
                loading: false,
                requested: false,
            };
        }

        default: {
            return {
            ...state,
            };
        }
    }
  };
  
  export default departmentsStore;
  